import styled from "styled-components";

export const Container = styled.div`
display: flex;
    //background-color: red;
    @media screen and (max-width: 1024px) {
        display: none;
    }
`